<template>
  <div class="student-selecter">
    <div class="value" v-for="item in selected" :key="item.id">
      <span
        v-if="item.photo"
        class="avatar"
        :style="'background-image:url(' + item.photo + ')'"
      ></span>
      <span v-else class="icon-text">{{
        (item.firstName + ' ' + item.lastName).toUpperCase() | getIconText
      }}</span>
      <span class="name">{{ item.firstName + ' ' + item.lastName }}</span>
    </div>
    <el-button class="edit-btn" type="text" @click="editStudent" v-if="!readOnly"
      ><el-tooltip
        popper-class="file-tooltip-top"
        :visible-arrow="false"
        content="Edit"
        placement="bottom"
        ><svg-icon iconClass="icon-edit" /></el-tooltip
    ></el-button>
    <div class="selecter-box" v-if="selecting">
      <div class="hd">Select student</div>
      <div class="ct">
        <div class="values">
          <div class="value" v-for="item in selectedTemp" :key="item.id">
            <span
              v-if="item.photo"
              class="avatar"
              :style="'background-image:url(' + item.photo + ')'"
            ></span>
            <span v-else class="icon-text">{{
              (item.firstName + ' ' + item.lastName).toUpperCase() | getIconText
            }}</span>
            <span class="name">{{ item.firstName + ' ' + item.lastName }}</span>
            <el-button type="text" icon="el-icon-error" @click="checkItem(item)"></el-button>
          </div>
        </div>
        <div class="options">
          <div class="tit">SEARCH RESULTS</div>

          <div class="item" @click="checkAll">
            <span class="checkbox" :class="{ checked: isCheckAll }">
              <i class="el-icon-check"></i>
            </span>
            <span
              class="avatar"
              :style="
                'background-image:url(' + require('@/assets/images/icons/student-all.png') + ')'
              "
            ></span>
            <div class="wd">
              <div class="wd-main">
                <span class="name">Select all</span>
              </div>
            </div>
          </div>
          <div class="item" v-for="item in options" :key="item.id" @click="checkItem(item)">
            <span class="checkbox" :class="{ checked: selectedTemp.find((o) => o.id == item.id) }">
              <i class="el-icon-check"></i>
            </span>
            <span
              v-if="item.photo"
              class="avatar"
              :style="'background-image:url(' + item.photo + ')'"
            ></span>
            <span v-else class="icon-text">{{
              (item.firstName + ' ' + item.lastName).toUpperCase() | getIconText
            }}</span>
            <div class="wd">
              <div class="wd-main">
                <span class="name">{{ item.firstName + ' ' + item.lastName }}</span>
                <span class="mail">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ft">
        <span class="btn" @click="handleCancel"> Cancel </span>
        <span class="btn" :class="{ disabled: confirmDisable }" @click="handleOk"> Select </span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
export default {
  components: { SvgIcon },
  props: {
    defaultValue: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: [], // 当前值
      selecting: false,
      selectedTemp: [] // 当前操作中的值，未确定
    }
  },
  computed: {
    isCheckAll() {
      return this.selectedTemp.length !== 0 && this.selectedTemp.length === this.options.length
    },
    confirmDisable() {
      return JSON.stringify(this.selected) == JSON.stringify(this.selectedTemp)
    }
  },
  mounted() {
    this.init()
  },
  filters: {
    getIconText(text) {
      if (!text) {
        return ''
      }
      const arr = text.split(' ')
      const first = arr[0].substr(0, 1)
      if (arr.length > 1) {
        const last = arr[arr.length - 1].substr(0, 1)
        return `${first}${last}`
      }
      return first
    }
  },
  methods: {
    init() {
      this.selected = [...this.defaultValue]
      this.selectedTemp = [...this.defaultValue]
    },
    editStudent() {
      this.init()
      this.selecting = true
    },
    handleCancel() {
      this.selecting = false
    },
    handleOk() {
      if (this.confirmDisable) {
        return
      }
      this.selecting = false
      this.selected = [...this.selectedTemp]
      this.$emit('onCheck', this.selected)
    },
    checkAll() {
      if (this.isCheckAll) {
        // 取消全选
        this.selectedTemp = []
      } else {
        // 全选
        this.selectedTemp = [...this.options]
      }
    },
    checkItem(item) {
      const _i = this.selectedTemp.findIndex((o) => o.id == item.id)
      if (_i >= 0) {
        // 取消选中
        this.selectedTemp.splice(_i, 1)
      } else {
        // 选中
        this.selectedTemp.push(item)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.student-selecter {
  padding-right: 34px;
  position: relative;
  .value {
    display: inline-block;
    height: 32px;
    line-height: 30px;
    padding: 0 5px;
    border: 1px solid #e0e0e0;
    border-radius: 15px;
    font-size: 0;
    margin: 0 8px 4px 0;
    cursor: default;
    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      vertical-align: middle;
      display: inline-block;
      background-color: #eee;
    }
    .icon-text {
      border-radius: 50%;
      text-align: center;
      align-items: center;
      justify-content: center;
      background: #b4b4b4;
      color: #fff;
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-family: 'opensans-semibold';
      vertical-align: middle;
      display: inline-block;
    }
    .name {
      font-size: 14px;
      color: #202124;
      margin-left: 8px;
      vertical-align: middle;
    }
    .el-button {
      padding: 0;
      vertical-align: middle;
      color: #5f6368;
      font-size: 20px;
      margin-left: 8px;
    }
  }

  .edit-btn {
    position: absolute;
    right: 0;
    top: 4px;
    padding: 0;
    width: 24px;
    height: 24px;
    border: 0 none;
    .svg-icon {
      width: 24px;
      height: 24px;
    }
  }
  .selecter-box {
    position: absolute;
    z-index: 999;
    left: 0;
    top: -62px;
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    .hd {
      padding: 20px 24px;
      line-height: 22px;
      color: #202124;
      font-size: 16px;
      border-bottom: 1px solid #e0e0e0;
    }
    .ct {
      padding: 24px;
      .values {
        padding: 4px 0;
        border-bottom: 1px solid #1a73e8;
        min-height: 41px;
      }
      .options {
        margin-top: 25px;
        .tit {
          line-height: 16px;
          color: #5f6368;
          font-size: 12px;
        }
        .item {
          height: 36px;
          line-height: 36px;
          padding: 0 5px;
          font-size: 0;
          margin-top: 20px;
          cursor: pointer;
          .checkbox {
            height: 20px;
            width: 20px;
            line-height: 16px;
            text-align: center;
            display: inline-block;
            border: 2px solid #5f6368;
            border-radius: 2px;
            vertical-align: middle;
            margin-right: 18px;
            .el-icon-check {
              font-size: 16px;
              color: #fff;
              display: none;
            }
            &.checked {
              border-color: #1a73e8;
              background: #1a73e8;
              .el-icon-check {
                display: block;
              }
            }
          }
          .avatar {
            width: 32px;
            height: 32px;
            border-radius: 100%;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: #eee;
            vertical-align: middle;
            display: inline-block;
            margin-right: 18px;
          }
          .icon-text {
            border-radius: 50%;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #b4b4b4;
            width: 32px;
            height: 32px;
            margin-right: 18px;
            line-height: 32px;
            font-size: 12px;
            font-family: 'opensans-semibold';
            vertical-align: middle;
            display: inline-block;
          }
          .wd {
            vertical-align: middle;
            display: inline-block;
          }
          .wd-main {
            display: flex;
            flex-direction: column;
          }
          .name {
            font-size: 14px;
            color: #202124;
            line-height: 20px;
            font-family: Roboto;
            font-weight: 500;
          }
          .mail {
            font-size: 12px;
            color: #202124;
            line-height: 16px;
            font-family: Roboto;
            font-weight: 400;
          }
        }
      }
    }
    .ft {
      padding: 8px 20px;
      line-height: 44px;
      border-top: 1px solid #e0e0e0;
      text-align: right;
      .btn {
        display: inline-block;
        line-height: 44px;
        color: #5f6368;
        font-size: 13px;
        padding: 0 12px;
        margin-left: 12px;
        cursor: pointer;
        &.disabled {
          color: #b4b4b4;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
